<style lang="scss" scoped>
.el-header {
  background-color: #264f78;
  // padding: 0 0 0 190px;
  height: 60px !important;
  min-width: 1200px;
  padding: 0;
}
.contents {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  // grid-template-columns: repeat(3, 1fr); // 三个重复的column，宽度，和下面可以混写
  grid-template-columns: 1fr 100px 100px 100px; // 可以写好多个，fr表示可用空间的一等分
  grid-gap: 10px; // 设置column之间的间隔
  grid-auto-rows: minmax(60px, auto); // 不支持百分比，设置row的最小和最大高
  color: white;
  .logo {
    // line-height: 60px;
    height: 60px;
    // display: inline-block;
    display: flex;
    flex-direction: column;
    justify-content: center;
    img {
      width: 100%;
      line-height: 0;
    }
    p {
      margin: 2px;
      font-size: 12px;
      font-style: normal;
      line-height: 12px;
    }
  }
  .deviceTest {
    line-height: 60px;
    font-weight: bold;
    &:hover {
      cursor: pointer;
    }
  }
  .title {
    line-height: 60px;
    text-align: left;
    font-size: 24px;
    font-weight: bold;
  }
  .support,
  .resetpwd,
  .logout {
    line-height: 60px;
    font-weight: bold;
    img {
      transform: translateX(-5px) translateY(2px);
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.helpWrapper {
  display: grid;
  grid-template-columns: 100px 1fr;
  .label {
    margin: 0;
  }
  .contact {
    text-align: left;
    grid-column-start: 2;
    grid-column-end: 3;
  }
}
</style>
<template>
  <el-header>
    <!-- <slot name="headerContent"></slot> -->
    <div class="contents">
      <!-- <div class="logo">
        <img src="../assets/images/b-logo.png" alt>
        <p>官方授权合作方</p>
      </div>-->
      <!-- <span class="title"> 蓝桥杯在线考试平台</span> -->
      <span class="title"> {{typeHash === '#normal' ? '编玩边学在线考试平台' : ' 蓝桥杯在线考试平台'}}</span>
      <!-- <span @click="handleCheckDevice" class="deviceTest">设备检测</span> -->
    </div>

  </el-header>
</template>
<script>

export default {
  name: 'BaseNav',
  componentName: 'BaseAdminNav',
  data() {
    return {
      typeHash: sessionStorage.getItem('hash') || this.$route.hash,
    };
  },
  props: {

  },
  watch: {},

  computed: {

  },
};
</script>
